@if (leadStatus !== approvedStatus && showUpload) {
<div class="ppl-mt20">
  @if(!readonly){
  <nz-form-item class="ppl-form-item pt-2">
    <nz-form-control class="ppl-form-control" [nzSm]="8" [nzXs]="24">
      <p style="font-size:0.929rem;">{{message}}</p>
      <ppl-upload (filesUploaded)="filesUploaded($event)" [fileList]="fileList" [flow]="entry" [leadId]="leadId"
        [docTypeList]="licences" [showFileList]="false"></ppl-upload>
    </nz-form-control>
  </nz-form-item>
  }
</div>
}
@if(entry === 'provider' && filedInfo?.providerDocumentDetails.length > 0){
@if(isMobileView) {
<div class="card-layout">
  <div class="card" *ngFor="let file of fileListInfo">
    <div class="card-item mt-2">
      <strong>{{ file.fileName }}</strong>
    </div>
    <div class="card-item">
      {{ file.lkpValueName }}
    </div>
    <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
      <div class="mr-3">
        <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: file, action: 'download'})"></ppl-button>
      </div>

      <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
        [iconPosition]="'left'" (click)="action({data: file, action: 'delete'})"></ppl-button>
    </div>
  </div>
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="!readonly" [data]="fileListInfo"
  [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
  (gridAction)="action($event)" [actionButtons]="actionButtons">
</ppl-list-table>
}
}
@else if (entry === 'referral' && filedInfo?.referralDocumentDetails.length > 0) {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="!readonly" [data]="fileListInfo"
  [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
  (gridAction)="action($event)" [actionButtons]="actionButtons">
</ppl-list-table>
}
@else if (entry === 'participantEnrollment' && filedInfo?.participantEnrlDocumentDetails?.length > 0) {
@if(isMobileView) {
<div class="card-layout">
  <div class="card" *ngFor="let file of fileListInfo">
    <div class="card-item mt-2">
      <strong>{{ file.fileName }}</strong>
    </div>
    <div class="card-item">
      {{ file.lkpValueName }}
    </div>
    <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
      <div class="mr-3">
        <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: file, action: 'download'})"></ppl-button>
      </div>

      <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
        [iconPosition]="'left'" (click)="action({data: file, action: 'delete'})"></ppl-button>
    </div>
  </div>
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
  [enableActions]="!!showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true" [cols]="cols"
  [gridTitle]="false" [pagination]="false" [loadPage]="true" (gridAction)="action($event)"
  [actionButtons]="actionButtons">
</ppl-list-table>
}
}
@else if (entry === 'providerEnrollment' && filedInfo?.providerEnrlDocumentDetails?.length > 0) {
@if(isMobileView) {
<div class="card-layout">
  <div class="card" *ngFor="let file of fileListInfo">
    <div class="card-item mt-2">
      <strong>{{ file.fileName }}</strong>
    </div>
    <div class="card-item">
      {{ file.lkpValueName }}
    </div>
    <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
      <div class="mr-3">
        <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: file, action: 'download'})"></ppl-button>
      </div>

      <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
        [iconPosition]="'left'" (click)="action({data: file, action: 'delete'})"></ppl-button>
    </div>
  </div>
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
  [enableActions]="!!showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true" [cols]="cols"
  [gridTitle]="false" [pagination]="false" [loadPage]="true" (gridAction)="action($event)"
  [actionButtons]="actionButtons">
</ppl-list-table>
}
}
@else if (entry === 'auth' && filedInfo?.consumerAuthDocumentDetailsList?.length > 0) {
<div class="auth-table-width">
  @if(isMobileView) {
  <div class="card-layout">
    <div class="card" *ngFor="let file of fileListInfo">
      <div class="card-item mt-2">
        <strong>{{ file.fileName }}</strong>
      </div>
      <div class="card-item">
        {{ file.lkpValueName }}
      </div>
      <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
        <div class="mr-3">
          <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="action({data: file, action: 'download'})"></ppl-button>
        </div>

        <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: file, action: 'delete'})"></ppl-button>
      </div>
    </div>
  </div>
  } @else {
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
    [enableActions]="!!showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true" [cols]="cols"
    [gridTitle]="false" [pagination]="false" [loadPage]="true" (gridAction)="action($event)"
    [actionButtons]="actionButtons">
  </ppl-list-table>
  }
</div>
}
@else if (summary){
<nz-row>
  <p>No Files Uploaded</p>
</nz-row>
}